// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductBadges_container__1A4Ml","badge":"ProductBadges_badge__PRhPM"};